import { i18n } from '@/locales';
import { getGlobalStore } from '@/lib/global-store';
import { pageTypeList } from '@/constants/userManagement/pageTypeList';
import { routeName } from './routeName';
const t = i18n.t.bind(i18n);
export const headerControllerMapper = {
    [routeName.WELCOME]: {
        component: 'Welcome/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const userName = vuexStore.getters['user/userName'];
            const path = 'views.welcome.page_title';
            return t(path, {
                userName,
            });
        },
    },
    [routeName.BAROGO_NOTICE]: {
        component: 'BarogoNotice/List/',
        getPageTitle: () => {
            const path = 'views.menu.barogo_notice';
            return t(path);
        },
    },
    [routeName.BAROGO_NOTICE_DETAIL]: {
        component: 'BarogoNotice/Detail/',
        getPageTitle: () => {
            const path = 'views.menu.barogo_notice';
            return t(path);
        },
    },
    [routeName.MEMBER_COMPANY_INQUIRY]: {
        component: 'MemberCompanyInquiry/List/',
        getPageTitle: () => {
            const path = 'views.menu.member_company_inquiry';
            return t(path);
        },
    },
    [routeName.MEMBER_COMPANY_INQUIRY_CREATE]: {
        component: 'MemberCompanyInquiry/Edit/',
        getPageTitle: () => {
            const path = 'views.menu.member_company_inquiry';
            return t(path);
        },
    },
    [routeName.MEMBER_COMPANY_INQUIRY_DETAIL]: {
        component: 'MemberCompanyInquiry/Detail/',
        getPageTitle: () => {
            const path = 'views.menu.member_company_inquiry';
            return t(path);
        },
    },
    [routeName.MEMBER_COMPANY_INQUIRY_EDIT]: {
        component: 'MemberCompanyInquiry/Edit/',
        getPageTitle: () => {
            const path = 'views.menu.member_company_inquiry';
            return t(path);
        },
    },
    [routeName.DISTRIBUTOR_NOTICE]: {
        component: 'DistributorNotice/List/',
        getPageTitle: () => {
            const path = 'views.menu.distributor_notice';
            const vuexStore = getGlobalStore();
            const distName = vuexStore.getters['user/distributorName'];
            return `${t(path)} / ${distName}`;
        },
    },
    [routeName.DISTRIBUTOR_NOTICE_CREATE]: {
        component: 'DistributorNotice/Edit/',
        getPageTitle: () => {
            const path = 'views.menu.distributor_notice';
            const vuexStore = getGlobalStore();
            const distName = vuexStore.getters['user/distributorName'];
            return `${t(path)} / ${distName}`;
        },
    },
    [routeName.DISTRIBUTOR_NOTICE_EDIT]: {
        component: 'DistributorNotice/Edit/',
        getPageTitle: () => {
            const path = 'views.menu.distributor_notice';
            const vuexStore = getGlobalStore();
            const distName = vuexStore.getters['user/distributorName'];
            return `${t(path)} / ${distName}`;
        },
    },
    [routeName.DISTRIBUTOR_NOTICE_DETAIL]: {
        component: 'DistributorNotice/Detail/',
        getPageTitle: () => {
            const path = 'views.menu.distributor_notice';
            const vuexStore = getGlobalStore();
            const distName = vuexStore.getters['user/distributorName'];
            return `${t(path)} / ${distName}`;
        },
    },
    // 상점 업무 처리
    [routeName.STORE_WORK_PROCESS]: {
        component: 'StoreWorkProcess/List/',
        getPageTitle: () => {
            const path = 'views.menu.store_work_process';
            return t(path);
        },
    },
    [routeName.STORE_WORK_PROCESS_DETAIL]: {
        component: 'StoreWorkProcess/Detail/',
        getPageTitle: () => {
            const path = 'views.menu.store_work_process';
            return t(path);
        },
    },
    [routeName.STORE_WORK_PROCESS_EDIT]: {
        component: 'StoreWorkProcess/Edit/',
        getPageTitle: () => {
            const path = 'views.menu.store_work_process';
            return t(path);
        },
    },
    [routeName.STORE_WORK_PROCESS_CREATE]: {
        component: 'StoreWorkProcess/Edit/',
        getPageTitle: () => {
            const path = 'views.menu.store_work_process';
            return t(path);
        },
    },
    [routeName.STORE_WORK_PROCESS_CREATE_REPLY]: {
        component: 'StoreWorkProcess/Edit/',
        getPageTitle: () => {
            const path = 'views.menu.store_work_process';
            return t(path);
        },
    },
    [routeName.STORE_WORK_PROCESS_EDIT_REPLY]: {
        component: 'StoreWorkProcess/Edit/',
        getPageTitle: () => {
            const path = 'views.menu.store_work_process';
            return t(path);
        },
    },
    // 라이더 공지사항
    [routeName.WORKER_NOTICE]: {
        component: 'WorkerNotice/List/',
        getPageTitle: () => {
            const path = 'views.menu.worker_notice';
            const vuexStore = getGlobalStore();
            const distName = vuexStore.getters['user/distributorName'];
            return `${t(path)} / ${distName}`;
        },
    },
    [routeName.WORKER_NOTICE_CREATE]: {
        component: 'WorkerNotice/Edit/',
        getPageTitle: () => {
            const path = 'views.menu.worker_notice';
            const vuexStore = getGlobalStore();
            const distName = vuexStore.getters['user/distributorName'];
            return `${t(path)} / ${distName}`;
        },
    },
    [routeName.WORKER_NOTICE_EDIT]: {
        component: 'WorkerNotice/Edit/',
        getPageTitle: () => {
            const path = 'views.menu.worker_notice';
            const vuexStore = getGlobalStore();
            const distName = vuexStore.getters['user/distributorName'];
            return `${t(path)} / ${distName}`;
        },
    },
    [routeName.WORKER_NOTICE_DETAIL]: {
        component: 'WorkerNotice/Detail/',
        getPageTitle: () => {
            const path = 'views.menu.worker_notice';
            const vuexStore = getGlobalStore();
            const distName = vuexStore.getters['user/distributorName'];
            return `${t(path)} / ${distName}`;
        },
    },
    [routeName.REQUEST_MAP]: {
        component: 'RequestMap/List/',
        getPageTitle: () => {
            const path = 'views.menu.request_map';
            return t(path);
        },
    },
    [routeName.REQUEST_MAP_CREATE]: {
        component: 'RequestMap/Create/',
        getPageTitle: () => {
            const path = 'views.menu.request_map';
            return t(path);
        },
    },
    [routeName.REPORT_DOWNLOAD]: {
        component: 'ReportDownload/List/',
        getPageTitle: () => {
            const path = 'views.menu.report_download';
            return t(path);
        },
    },
    [routeName.BAROMONEY_TRANSFER_SETTING]: {
        component: 'BaromoneyTransferSetting/List/',
        getPageTitle: () => {
            const path = 'views.menu.baromoney_transfer_setting';
            return t(path);
        },
    },
    [routeName.BAROMONEY_TRANSFER_SETTING_DETAIL]: {
        component: 'BaromoneyTransferSetting/Detail/',
        getPageTitle: () => {
            const path = 'views.menu.baromoney_transfer_setting';
            return t(path);
        },
    },
    [routeName.BAROMONEY_ACCOUNT_RECEIVABLE_LIST]: {
        component: 'BaromoneyAccountReceivableList/List/',
        getPageTitle: () => {
            const path = 'views.menu.baromoney_account_receivable_list';
            return t(path);
        },
    },
    [routeName.BAROMONEY_ACCRUED_EXPENSES_LIST]: {
        component: 'BaromoneyAccruedExpensesList/List/',
        getPageTitle: () => {
            const path = 'views.menu.baromoney_accrued_expenses_list';
            return t(path);
        },
    },
    [routeName.OPERATION_SETTING]: {
        component: 'OperationSetting/',
        getPageTitle: () => {
            const path = 'views.operation_setting.page_title';
            return t(path);
        },
    },
    [routeName.DELIVERY_HISTORY]: {
        component: 'DeliveryHistory/',
        getPageTitle: () => {
            const path = 'views.delivery_history.page_title';
            return t(path);
        },
    },
    [routeName.LIST_CONTROL]: {
        component: 'ListControl/',
        getPageTitle: () => {
            const path = 'views.list_control.page_title';
            return t(path);
        },
    },
    [routeName.WORKER_MANAGEMENT]: {
        component: 'WorkerManagement/WorkerList/',
        getPageTitle: () => {
            const path = 'views.worker_management.page_title';
            return t(path);
        },
    },
    [routeName.WORKER_MANAGEMENT_DELIVERY_FEE_GROUP_SETTING]: {
        component: 'WorkerManagement/DeliveryFeeGroupSetting/',
        getPageTitle: () => {
            const path = 'views.delivery_fee_group_setting.page_title';
            return t(path);
        },
    },
    [routeName.WORKER_MANAGEMENT_CASH_AUTO_DEDUCT_GROUP_SETTING]: {
        component: 'WorkerManagement/CashAutoDeductGroupSetting/',
        getPageTitle: () => {
            const path = 'views.cash_auto_deduct_group_setting.page_title';
            return t(path);
        },
    },
    [routeName.WORKER_MANAGEMENT_ALLOCATED_CANCEL_PENALTY_GROUP_SETTING]: {
        component: 'WorkerManagement/AllocatedCancelPenaltyGroupSetting/',
        getPageTitle: () => {
            const path = 'views.allocated_cancel_penalty_group_setting.page_title';
            return t(path);
        },
    },
    [routeName.WORKER_MANAGEMENT_WORKER_CREATE]: {
        component: 'WorkerManagement/WorkerCreate/',
        getPageTitle: () => {
            const path = 'views.worker_management.registration';
            return t(path);
        },
    },
    [routeName.WORKER_MANAGEMENT_WORKER_DETAIL]: {
        component: 'WorkerManagement/WorkerDetail/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const selectedName = vuexStore.getters['workerManagement/workerDetail/getterSelectedWorkerName'];
            const path = 'views.worker_management_detail.page_title';
            return [
                t(path),
                selectedName,
            ];
        },
    },
    [routeName.WORKER_MANAGEMENT_WORKER_EDIT]: {
        component: 'WorkerManagement/WorkerEdit/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const selectedName = vuexStore.getters['workerManagement/workerEdit/getterSelectedWorkerName'];
            const path = 'views.worker_management_detail.page_title';
            return [
                t(path),
                selectedName,
            ];
        },
    },
    [routeName.WORKER_BAROMONEY_HISTORY]: {
        component: 'WorkerBaromoneyHistory/',
        getPageTitle: () => {
            const path = 'views.worker.worker_baromoney_history.page_title';
            return t(path);
        },
    },
    [routeName.WORKER_PROFIT]: {
        component: 'WorkerProfit/',
        getPageTitle: () => {
            const path = 'views.worker.worker_profit.page_title';
            return t(path);
        },
    },
    [routeName.WORKER_MONTHLY_ATTENDANCE]: {
        component: 'WorkerMonthlyAttendance/',
        getPageTitle: () => {
            const path = 'views.worker.worker_monthly_attendance.page_title';
            return t(path);
        },
    },
    [routeName.STORE_STATS]: {
        component: 'StoreStats/',
        getPageTitle: () => '상점 통계',
    },
    [routeName.STORE_MANAGEMENT]: {
        component: 'StoreManagement/StoreList/',
        getPageTitle: () => {
            const path = 'views.store_management.page_title';
            return t(path);
        },
    },
    [routeName.STORE_MANAGEMENT_WORKER_FEE_PER_STORE_GROUP_SETTING]: {
        component: 'StoreManagement/WorkerFeePerStoreGroupSetting/',
        getPageTitle: () => {
            const path = 'views.worker_fee_per_store_group_setting.page_title';
            return t(path);
        },
    },
    [routeName.STORE_MANAGEMENT_CREATE]: {
        component: 'StoreManagement/StoreCreate/',
        getPageTitle: () => {
            const path = 'views.store_management.registration';
            return t(path);
        },
    },
    [routeName.STORE_MANAGEMENT_DETAIL]: {
        component: 'StoreManagement/StoreDetail/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const selectedName = vuexStore.getters['storeManagement/storeDetail/getterSelectedStoreName'];
            const path = 'views.store_management_detail.page_title';
            return [
                t(path),
                selectedName,
            ];
        },
    },
    [routeName.STORE_MANAGEMENT_EDIT]: {
        component: 'StoreManagement/StoreEdit/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const selectedName = vuexStore.getters['storeManagement/storeEdit/getterSelectedStoreName'];
            const path = 'views.store_management_detail.page_title';
            return [
                t(path),
                selectedName,
            ];
        },
    },
    [routeName.HUB_MANAGEMENT]: {
        component: 'HubManagement/HubList/',
        getPageTitle: () => {
            const path = 'views.hub_management.page_title';
            return t(path);
        },
    },
    [routeName.HUB_MANAGEMENT_CREATE]: {
        component: 'HubManagement/HubCreate/',
        getPageTitle: () => {
            const path = 'views.hub_management.registration';
            return t(path);
        },
    },
    [routeName.HUB_MANAGEMENT_DETAIL]: {
        component: 'HubManagement/HubDetail/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const selectedName = vuexStore.getters['hubManagement/hubDetail/getterSelectedHubName'];
            const path = 'views.hub_management_detail.page_title';
            return t(path, {
                name: selectedName,
            });
        },
    },
    [routeName.HUB_MANAGEMENT_EDIT]: {
        component: 'HubManagement/HubEdit/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const selectedName = vuexStore.getters['hubManagement/hubEdit/getterSelectedHubName'];
            const path = 'views.hub_management_detail.page_title';
            return t(path, {
                name: selectedName,
            });
        },
    },
    [routeName.HUB_ADJUSTMENT]: {
        component: 'HubAdjustment/Main/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const selectedName = vuexStore.getters['hubAdjustment/hubMainReport/getterSelectedHubName'];
            const path = 'views.hub_adjustment.page_title';
            return t(path, {
                name: selectedName,
            });
        },
    },
    [routeName.HUB_ADJUSTMENT_TEST_MODE_ENTRANCE]: {
        component: 'HubAdjustment/TestModeEntrance/',
        getPageTitle: () => {
            const path = 'views.hub_adjustment.hub_adjustment_test_mode_entrance';
            return t(path);
        },
    },
    // 허브 정산
    [routeName.HUB_STATS]: {
        component: 'HubStats/',
        getPageTitle: () => {
            const path = 'views.hub_stats.page_title';
            return t(path);
        },
    },
    // 허브 정산
    [routeName.HUB_STATS_DAILY]: {
        component: 'HubStatsDaily/',
        getPageTitle: () => {
            const path = 'views.hub_stats_daily.page_title';
            return t(path);
        },
    },
    // 허브 정산
    [routeName.HUB_STATS_MONTHLY]: {
        component: 'HubStatsMonthly/',
        getPageTitle: () => {
            const path = 'views.hub_stats_monthly.page_title';
            return t(path);
        },
    },
    // 허브 정산
    [routeName.HUB_STATS_HOURLY]: {
        component: 'HubStatsHourly/',
        getPageTitle: () => {
            const path = 'views.hub_stats_hourly.page_title';
            return t(path);
        },
    },
    // 허브 정산
    [routeName.HUB_STATS_DAY_OF_WEEK]: {
        component: 'HubStatsDayOfWeek/',
        getPageTitle: () => {
            const path = 'views.hub_stats_day_of_week.page_title';
            return t(path);
        },
    },
    [routeName.WORKER_ADJUSTMENT]: {
        component: 'WorkerAdjustment/',
        getPageTitle: () => {
            const path = 'views.worker_adjustment.page_title';
            return t(path);
        },
    },
    [routeName.WORKER_INFORMATION_DETAIL]: {
        component: 'WorkerAdjustment/DetailsPerWorker/Detail/',
        getPageTitle: () => {
            const path = 'views.worker_information_detail.page_title';
            return t(path);
        },
    },
    [routeName.STORE_ADJUSTMENT]: {
        component: 'StoreAdjustment/',
        getPageTitle: () => {
            const path = 'views.store_adjustment.page_title';
            return t(path);
        },
    },
    [routeName.STORE_ADJUSTMENT_DETAIL]: {
        component: 'StoreAdjustment/Detail/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const consumerName = vuexStore.getters['storeAdjustmentDetail/getterConsumerStoreName'];
            const path = 'views.store_adjustment_detail.page_title';
            return t(path, {
                storeName: consumerName,
            });
        },
    },
    [routeName.SALES]: {
        component: 'Sales/',
        getPageTitle: () => {
            const path = 'views.sales.page_title';
            return t(path);
        },
    },
    [routeName.BAROMONEY_REPORT]: {
        component: 'BaromoneyReport/',
        getPageTitle: () => {
            const path = 'views.baromoney_report.page_title';
            return t(path);
        },
    },
    [routeName.TEMPORARY]: {
        component: 'Temporary/',
        getPageTitle: () => {
            const path = 'views.temporary.page_title';
            return t(path);
        },
    },
    [routeName.DESIGN_SYSTEM_TEXT]: {
        component: 'DesignSystem/Text/',
        getPageTitle: () => {
            const path = 'views.design_system_text.page_title';
            return t(path);
        },
    },
    [routeName.DESIGN_SYSTEM_FORM]: {
        component: 'DesignSystem/Form/',
        getPageTitle: () => {
            const path = 'views.design_system_form.page_title';
            return t(path);
        },
    },
    [routeName.DESIGN_SYSTEM_BUTTON]: {
        component: 'DesignSystem/Button/',
        getPageTitle: () => {
            const path = 'views.design_system_button.page_title';
            return t(path);
        },
    },
    [routeName.USER_MANAGEMENT]: {
        component: 'UserManagement/UserList/',
        getPageTitle: () => {
            const path = 'views.user_management.page_title';
            return t(path);
        },
    },
    [routeName.USER_MANAGEMENT_CREATE]: {
        component: 'UserManagement/UserPage/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const pageType = vuexStore.getters['userManagement/userPage/getterPageType'];
            const userId = vuexStore.getters['userManagement/userPage/getterUserId'];
            const path = 'views.user_management_page.page_title';
            const withSlashPath = 'views.user_management_page.with_slash_path';
            const isSlashNeedPage = pageType !== pageTypeList.CREATE.value;
            let currentPath = path;
            // 등록 페이지 제외 '/ {선택이름}' 출력
            if (isSlashNeedPage) {
                currentPath = withSlashPath;
            }
            return t(currentPath, {
                userId,
            });
        },
    },
    [routeName.USER_MANAGEMENT_PAGE]: {
        component: 'UserManagement/UserPage/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const pageType = vuexStore.getters['userManagement/userPage/getterPageType'];
            const userId = vuexStore.getters['userManagement/userPage/getterUserId'];
            const path = 'views.user_management_page.page_title';
            const withSlashPath = 'views.user_management_page.with_slash_path';
            const isSlashNeedPage = pageType !== pageTypeList.CREATE.value;
            let currentPath = path;
            // 등록 페이지 제외 '/ {선택이름}' 출력
            if (isSlashNeedPage) {
                currentPath = withSlashPath;
            }
            return t(currentPath, {
                userId,
            });
        },
    },
    [routeName.SHARE_MANAGEMENT]: {
        component: 'ShareManagement/ShareList/',
        getPageTitle: () => {
            const path = 'views.share_management.page_title';
            return t(path);
        },
    },
    [routeName.SHARE_MANAGEMENT_CONFIG]: {
        component: 'ShareManagement/ShareConfig/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const name = vuexStore.getters['hubSelector/getterSubscribeHubName'];
            const code = vuexStore.getters['hubSelector/getterSubscribeHubId'];
            const path = 'views.share_management.share_config_page_title';
            return t(path, {
                name,
                code,
            });
        },
    },
    [routeName.DELIVERY_CHARGE_AREA_CONTROL]: {
        component: 'DeliveryChargeAreaControl/',
        getPageTitle: () => {
            const vuexStore = getGlobalStore();
            const name = vuexStore.getters['hubSelector/getterSubscribeHubName'];
            const code = vuexStore.getters['hubSelector/getterSubscribeHubId'];
            const path = 'views.delivery_charge_area_control.page_title';
            return t(path, {
                name,
                code,
            });
        },
    },
};
